module.exports = __webpack_public_path__ + "img/6.c8b42903.png";